import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getUserFullName, UserRole } from '../Services/AuthService';
import { useForm } from '../Context/FormContext';
import { useHeaderVisibility } from '../Context/HeaderVisibilityContext';

interface NavbarProps {
  user: any;
  onLogout: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ user, onLogout }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isSubmissionFormOpen } = useForm();
  const { isHeaderVisible } = useHeaderVisibility();
  const location = useLocation();
  
  // Check if we're on the user dashboard (home page)
  const isUserHome = location.pathname === '/user/dashboard';

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // For USER role, show simplified header with hover behavior
  if (user.role === UserRole.USER) {
    return (
      <>
        <div
          style={{
            opacity: isHeaderVisible ? 1 : 0,
            transition: 'opacity 0.3s ease',
            pointerEvents: isHeaderVisible ? 'auto' : 'none',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: isUserHome ? '20px 0 0 0' : '1.5rem 2rem',
            minHeight: isUserHome ? 'auto' : '100px',
            maxHeight: isUserHome ? '220px' : 'auto',
            backgroundColor: 'white'
          }}
        >
          {isUserHome ? (
            // Split layout for UserDashboard: Logo on left, header_clientes.svg on right
            <div className="header-split-layout" style={{ justifyContent: 'flex-end' }}>
              <div className="header-logo-section" style={{ display: 'none' }}>
                <img
                  src="/logos/logo-arquitectura.svg"
                  alt="Logo Arquitectura"
                  className="header-arquitectura-logo"
                />
              </div>
              <div className="header-image-section">
                <img
                  src="/images/header_clientes.svg"
                  alt="Header"
                  className="header-clientes-image"
                />
              </div>
            </div>
          ) : (
            // Centered logo for other USER pages
            <img
              src="/logos/logo-complet.avif"
              alt="Logo"
              style={{
                height: '70px',
                width: 'auto',
                position: 'absolute',
                left: '50%',
                transform: 'translateX(-50%)',
                paddingTop: '0.5rem',
                paddingBottom: '0.5rem'
              }}
            />
          )}
          {isUserHome && (
            <button
              className="logout-icon-btn"
              onClick={onLogout}
              aria-label="Cerrar sesión"
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'absolute',
                right: '2rem',
                top: '2rem',
                zIndex: 1001
              }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
            </button>
          )}
        </div>
      </>
    );
  }

  // Original navbar for other roles
  return (
    <>
      <div className={`header-container ${isHeaderVisible ? 'header-visible' : 'header-hidden'}`}>
        <img
          src="/images/header.svg"
          alt="Header"
          className="header-image"
        />
        {!isMenuOpen && !isSubmissionFormOpen && isHeaderVisible && (
          <button 
            className="burger-menu-btn"
            onClick={toggleMenu}    
            aria-label="Toggle menu"
          >
            <div className="burger-line"></div>
            <div className="burger-line"></div>
            <div className="burger-line"></div>
          </button>
        )}
      </div>
      
      <div className={`sidebar-menu ${isMenuOpen ? 'open' : ''}`}>
        <button 
          className="close-menu-btn"
          onClick={toggleMenu}
          aria-label="Cerrar menú"
        >
          ×
        </button>
        <div className="menu-header">
          <div className="user-info">
            <h5>{getUserFullName(user)}</h5>
            <p>{user.email}</p>
            <small className="user-role">{user.role}</small>
          </div>
        </div>
        
        <nav className="menu-nav">
          <Link to="/" className="menu-item" onClick={() => setIsMenuOpen(false)}>
            Inicio
          </Link>
          {user.role === UserRole.SUPERADMIN && (
            <>
              <Link to="/admin/projects" className="menu-item" onClick={() => setIsMenuOpen(false)}>
                Proyectos
              </Link>
              <Link to="/admin/architects" className="menu-item" onClick={() => setIsMenuOpen(false)}>
                Arquitectos
              </Link>
              <Link to="/admin/subscriptions" className="menu-item" onClick={() => setIsMenuOpen(false)}>
                Suscripciones
              </Link>
              <Link to="/configurador" className="menu-item" onClick={() => setIsMenuOpen(false)}>
                Configurador del Cuestionario
              </Link>
            </>
          )}
        </nav>
        
        <div className="menu-footer">
          <button 
            className="logout-btn-bottom"
            onClick={onLogout}
          >
            Cerrar Sesión
          </button>
        </div>
      </div>
      
      {isMenuOpen && <div className="menu-overlay" onClick={toggleMenu}></div>}
    </>
  );
};

export default Navbar;